import * as Immutable from "immutable"
import { HttpResult } from "widgets-for-react"
import { config_pages_footer_guard, config_pages_footer_parser } from "../../drupal/types_and_parser/parser.ext.gen"
import { ParsedConfigPagesFooter } from "../../drupal/types_and_parser/types.ext.gen"
import { PressContactConfig } from "./pressContactConfig"

type NamedId = {
  id: number,
  name: string
}

export type Specialism = NamedId

export const getSpecialisms = (lang: string): Promise<HttpResult<Immutable.List<Specialism>>> =>
  fetch(`/api/v1/peoplexs/specialisms/${lang}`)
    .then(res => res.json())
    .then(json => json)
    .then(value => ({
      kind: "result",
      status: 200,
      value: Immutable.List(value)
    }))

export type Location = NamedId

export const getLocations = (lang: string): Promise<HttpResult<Immutable.List<Location>>> =>
  fetch(`/api/v1/peoplexs/locations/${lang}`)
    .then(res => res.json())
    .then(json => json)
    .then(value => ({
      kind: "result",
      status: 200,
      value: Immutable.List(value)
    }))


export const getPressContact = (lang: string): Promise<HttpResult<PressContactConfig>> =>
  fetch(`/api/drupal/${lang}/api/configuration-pages/press${lang == 'nl' ? '_dutch' : ''}`)
    .then(res => res.json())
    .then(json => json)
    .then(contact => {
      if (contact.length == 0) return ({ kind: 'failed', status: 400 })
      return ({
        kind: "result",
        status: 200,
        value: contact[0]
      })
    })

export async function getFooterConfig (lang: string): Promise<HttpResult<ParsedConfigPagesFooter>> {
  const res = await fetch(`/api/drupal/${lang}/api/configuration-pages/footer`)
  
  if (!res.ok) return { kind: 'failed', status: 400 }

  const json: any = await res.json()
  let parsed: ParsedConfigPagesFooter
  let single_item = json[0]
  if (config_pages_footer_guard(single_item)) {
    parsed = config_pages_footer_parser(single_item)
  }

  return { kind: "result", value: parsed, status: 200 }
}